import { getAssetPath } from "@commonUtils"

export const LOGIN_ERROR_CONFIG = {
    header: "Oops! we apologise, an unexpected error occurred while signing you in",
    description:
        "Please make sure your interaction connect was not interrupted. If still there is an issue please try again in sometime",
    imageUrl: getAssetPath("illustrations/not-found.svg"),
    imageAltText: "Something wrong",
    ctaLabel: "Retry signing in",
}
export const LINK_EXPIRED_ERROR_CONFIG = {
    header: "Link Expired",
    description:
        "The link you are trying to open has expired, please contact your support for further details.",
    imageUrl: getAssetPath("illustrations/no-result-found.svg"),
    imageAltText: "Expired Link",
}

export const COMMON_ERROR_CONFIG = {
    header: "Sorry, something went wrong",
    description: "Were working towards creating something better. Please try again",
    imageUrl: getAssetPath("illustrations/not-available.svg"),
    imageAltText: "Something wrong",
}

export const MAX_PHONE_NUMBER_LENGTH = 10
export const VALID_PHONE_NUMBER_REGEX = /^\d*$/
export const INVALID_NUMBER_ERROR_MESSAGE = "Please enter a valid number"
